import { FunctionComponent } from 'react';
import {Card, Modal} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./ConfirmationModal.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../CustomButton/CustomButton';
interface IProps {
    showModal: boolean;
    title: string;
    bodyText: string | React.ReactNode | React.ReactElement;
    onClose: () => void;
    cancelBtnText?: string;
    submitBtnText?: string;
    submitBtnType?: ButtonType;
    onSubmit: () => void;
    className?: string;
    isSubmitDisabled?: boolean;
};

const ConfirmationModal: FunctionComponent<IProps> = ({title, showModal, bodyText, onClose, onSubmit, cancelBtnText,
    submitBtnText, submitBtnType, className, isSubmitDisabled}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.confirmationModal, className)}
        dialogClassName={styles.confirmationModalDialog}
        contentClassName={styles.confirmationModalContent}
        centered={true}
    >
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <Card.Text bsPrefix={styles.bodyText} as={'div'}>{bodyText}</Card.Text>
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            {cancelBtnText &&
                <CustomButton
                    className={styles.cancelBtn}
                    btnType={ButtonType.LIGHTBLUE}
                    btnRadius={ButtonRadiusSize.SMALL}
                    onClick={onClose}
                >
                    {cancelBtnText}
                </CustomButton>
            }
            {submitBtnText &&
                <CustomButton
                    className={cn(styles.confirmationModalBtn, styles.deleteBtn)}
                    btnType={ submitBtnType || ButtonType.GREEN}
                    btnRadius={ButtonRadiusSize.SMALL}
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                >
                    {submitBtnText}
                </CustomButton>
            }
        </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;